<template>
        <cookie/>
    <div class="FAQ-banner">
        <header>
          <div class="wrapper flex">
            <div class="lang" v-if="isActiveLang">
              <img src="../assets/img/lang.svg">
              <p class="lang-p">{{choiceLang}}</p>
              <img src="../assets/img/chevron-down.svg" class="left-strel pointer" @click="setActiveLang">
            </div>
            <div class="lang" v-if="!isActiveLang">
              <img src="../assets/img/lang.svg">
              <div style=" display: flex">
                <p class="lang-p pointer" @click="setLang('EN')">EN</p>
                <p class="lang-p pointer" @click="setLang('ES')">ES</p>
                <p class="lang-p pointer" @click="setLang('PT')">PT</p>
                <p class="lang-p pointer" @click="setLang('FR')">FR</p>
                <p class="lang-p pointer" @click="setLang('ZH')">ZH</p>
                <p class="lang-p pointer" @click="setLang('RU')">RU</p>
                <p class="lang-p pointer" @click="setLang('HE')">HE</p>
                <p class="lang-p pointer" @click="setLang('AR')">AR</p>
              </div>
              <img src="../assets/img/chevron-down.svg" class="top-strel pointer" @click="setActiveLang">
            </div>
            <nav class="flex-header-btn">
              <button class="border-btn pointer" @click="loginRediresct">{{lang[choiceLang]['Log in']}}</button>
              <button class="inline-btn ml-2 pointer" @click="signUpRediresct">{{lang[choiceLang]['Sign in']}}</button>
            </nav>
          </div>
        </header>
    </div>
    <div class="wrapper">
      <a href="/"><h2 class="FAQ-title mt-2 pointer" @click="$router.push('/')" style="font-size: 16px; color: rgba(242, 142, 34, 1); display: flex; align-items: center;margin-left: 0"><img src="../assets/img/chevron-down.svg" style="transform: rotate(90deg)">To Home Page</h2></a>
        <p class="FAQ-title mt-2" style="text-align: center">Cookie declaration<br/>
This website uses cookies. We use cookies to personalise content and ads, to provide social media features and to analyse our traffic. We also share information about your use of our site with our social media, advertising and analytics partners who may combine it with other information that you’ve provided to them or that they’ve collected from your use of their services.
<br/>
Cookies are small text files that can be used by websites to make a user's experience more efficient.
<br/>
The law states that we can store cookies on your device if they are strictly necessary for the operation of this site. For all other types of cookies we need your permission.
<Br/>
This site uses different types of cookies. Some cookies are placed by third party services that appear on our pages.
<br/>
You can at any time change or withdraw your consent from the Cookie Declaration on our website.
<br/>
Learn more about who we are, how you can contact us and how we process personal data in our Privacy Policy.
<br/>
Please state your consent ID and date when you contact us regarding your consent.
<br/>
Your consent applies to the following domains: www.merciq.com & www.merciq.app
<br/>
<span v-if="id != undefined">Your consent ID: {{id}} <br>
Consent date: {{date}}</span>
<table v-if="id != undefined">
  <tr>
    <td>Name</td>
    <td>Provider</td>
    <td>Type</td>
  </tr>
  <tr>
    <td>accept_cookie</td>
    <td>MerciQ</td>
    <td>HTTP cookie</td>
  </tr>
  <tr>
    <td>connect.sid</td>
    <td>MerciQ</td>
    <td>HTTP cookie</td>
  </tr>
</table>
<button v-if="id != undefined" class="border-btn mt-2 pointer" style="margin-left: auto; margin-right: auto" @click="clearCookie">Revoke cookies</button>
<span v-else>Accept cookies!</span>
</p>
    </div>
    <footer class="mt-2">
        <div class="wrapper">
          <div class="address">
            <a href="/" style="text-decoration: none"><h4>MERCI<span class="orange-color h4">Q</span></h4></a>
            <p class="mt-2">MerciQ Solutions LLC<br>7901 4th St. N<br>#17109<br>St. Petersburg, FL 33702</p>
          </div>
          <div class="links">
            <div><a href="https://merciq.app/docs/Terms%20and%20Conditions.pdf">Terms & Conditions</a></div>
            <div><a href="https://merciq.app/docs/Privacy%20Policy.pdf">Privacy Policy</a></div>
            <div><a href="https://merciq.app/docs/Fee%20Plan.pdf">Fee Plan</a></div>
            <div><a href="/Cookie%20policy.pdf">Cookie Policy</a></div>
            <div><a href="/cookie">Cookie declaration</a></div>
            <div><a href="/faq">FAQ</a></div>
            <div><a href="/contact">Contact Us</a></div>
            <!-- <div><a href="/blog">Blog & Updates</a></div> -->
          </div>
        </div>
      </footer>
</template>

<script>
  import langs from '../mixins/langs.js'

    export default {
        mixins: [langs],
        data() {
            return {
                username: '',
                show: false,
                isError: false,
                isActiveLang: true,
                choiceLang: 'EN',
                isActive: [0, 0, 0, 0],
                id: localStorage.getItem('cookie_id'),
                date: localStorage.getItem('date'),
                
            }
        },
        methods: {
          clearCookie() {
            localStorage.clear()
            this.$router.go()
          },
          signUpRediresct() {
            window.location.href = 'https://merciq.app/signupshort'
          },
          loginRediresct() {
            window.location.href = 'https://merciq.app/staff/signin'
          },
        }
       
    }
</script>